module.exports = {
  containsPhone: require("./containsPhone"),
  containsEmail: require("./containsEmail"),
  formatAmount: require("./formatAmount"),
  datesAreSame: require("./datesAreSame"),
  combineDateAndHour: require("./combineDateAndTime"),
  findRight: require("./findRight"),
};
